import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, OnDestroy, Inject } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'fury-assign-item-list',
  templateUrl: './assign-item-list.component.html',
  styleUrls: ['./assign-item-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class AssignItemListComponent implements OnInit, OnDestroy {

  itemList: any;
  filterValue: any;
  imageBasePath!: string;
  selection = new SelectionModel<any>(true, []);
  detailData: any;
  coveredItemForm!: FormGroup;
  loading:boolean=false;
  show = 5;
  searchText!: string;
  filterList = [];
  total: any;
  searchedKeyword: any;

  constructor(
    private apiservice: ApiService,
    private storage: StorageService,
    public dialogRef: MatDialogRef<AssignItemListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { this.filterValue = 'Covered Items' }

  ngOnInit(): void { this.getCoveredItemsList() }
  pageEvent(ev: any) { this.storage.setPage(ev, '_elitecoveredlist') }
  increaseShow() {  
    this.loading=true;  
    this.show += 5;
    this.selection.clear();
    this.getCoveredItemsList(); 
  }

  getCoveredItemsList() {
    this.apiservice.get(`admin/plan/covered-item/get-covered-items?page=1&size=${this.show}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchType=contains&searchBy=title`)
      .subscribe((res: HttpResponse<any>) => {
        if (res.status === 200) {
          this.loading=false;
            this.itemList = res.body.planCoverItems.data;
            this.filterList = this.itemList;
            this.total = res.body.planCoverItems.total;
            if (this.data) { this.getdetail(this.data) }
        }
      });
  }

  formInit() {
    this.coveredItemForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
    });
  }
  onFilterChange(event: any) {
      this.searchedKeyword =  event.target.value.trim(); this.getCoveredItemsList();
  }
  isAllSelected() {
    const numSelected = this.selection?.selected?.length;
    const numRows = this.itemList?.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.itemList?.forEach((row: any) => this.selection.select(row));
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection?.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  assignItems() {
    const temparr: any[] = [];
    this.selection.selected.map(item => { temparr.push(item['planCoverItemId']) });
    const data: any[] = [];
    for (let index = 0; index < temparr.length; index++) { data.push(temparr[index]) }
    const uniqueItems = Array.from(new Set(data));
    const obj = { planCoveredItemIds: uniqueItems}
    this.apiservice.patch(`admin/plan/optional-item-category/assign-covered-items/${this.data}`, obj)
    .subscribe({
      next: (res: HttpResponse<any>) => {
        if (res.status === 200) {
          this.apiservice.alert(res.body.message, 'success');
          this.getCoveredItemsList(); this.selection.clear(); this.cancel();
        } else {
          this.apiservice.alert(res.body.message, 'warning');
        }
      }, error: (err) => { if (err) this.apiservice.alert('Somthing Went Wrong', 'error') }
    })
  }
  ngOnDestroy() { }

  getdetail(categoryId: string) {
    this.apiservice.get(`admin/plan/optional-item-category/get-optional-item-category/${categoryId}`)
      .subscribe((res: HttpResponse<any>) => {
        if (res.status === 200) {
          this.detailData = res.body.planOptionalItemCategory;
          this.itemList?.map((val: any) => {
            this.detailData?.coveredItems?.forEach((element: any) => {
              if (element['planCoverItemId'] === val['planCoverItemId']) { this.selection.select(val) } else "NOt AVAILABLE!"
            });
          })
        }
      });
  }
  cancel(): void {
    this.dialogRef.close();
  }

}
